/**************************************************
 * Nombre:       Formulario_Blog
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, Flag} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSPRODUCTO} from "../../Constantes";
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoTextoEstilo from "../../Modulo_formularios/Componentes/IngresoTextoEstilo";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import {useEffect, useState} from "react";
import IngresoSelectTextoArray from "../../Modulo_formularios/Componentes/IngresoSelectTextoArray";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Blog = ({...props}) => {
    const [categorias, setCategorias] = useState([]);

    useEffect(() => {

        obtenerCol('categoriasBlog').then((dox) =>{
            setCategorias(dox.data)
        })

    },[])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop dato={'img'} {...props} ancho={10} alto={6} />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14}}>Peso Maximo 500k (1000px - 600px)</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSPRODUCTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoFecha nombre={'Fecha'} dato={'fechaPublicacion'} {...props}
                                  requerido={'El estado es requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={2} nombre={'Nombre del Blog'}
                                  dato={'nombre'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Autor'}
                                  dato={'autor'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={3} nombre={'Frase Destacada'}
                                  dato={'frase'} {...props}
                    />
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelectTextoArray nombre={'Categorias Blog'} dato={'categorias'} {...props}
                                           opciones={categorias.map(it => it.nombre)} />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTextoEstilo nombre={'Texto'} dato={'textoEstilo'} {...props}

                    />
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Blog